export const am = {
    home: {
        SLOGAN: 'ጉዳይ™',
        GOODAYWIQ: 'ጉዳይ™ ምንድን ነው ?',
        GOODAYWID: 'ጉዳይ™ የሞባይል አፕ GoodayOnline™ ከሚሰጣቸው አገልግሎቶች አንዱ ነው ። GoodayOnline™ በገበያና በሸማቾች (በተጠቃሚዎች) ላይ የሚያተኩር በ B2B2C ዲጂታል ማርኬቲንግ ላይ የተሰማራ ኩባንያ ነው ።  GoodayOnline™ የተመሰረተው በ 2019 እ.ኤ.አ ሲሆን በ አዲስ አበባና በ ቨርጂኒያ ዩ.ኤስ.ኤ ቅርንጫፍ መስሪያ ቤቶች አሉት ። "Gooday" የሚለው ቃል በእንግሊዝኛ "መልካም ቀን" የሚል መልእክት እንዲኖረውና በአማርኛ ደግሞ "ጉዳይ" የሚለውን ቃል እንዲወክል የተመረጠ ስም ነው ። GoodayOnline™ በአጭሩ በ ንግድ-እና-ንግድ እንዲሁም በ ንግድ-እና-በሸማች(ተጠቃሚ) መካከል ያሉ ግንኙነቶችን የሚያሳልጥ የቴክኖሎጂኩባንያ ነው።',
        GOODAYWHYQ: 'ጉዳይ™ ለምን ይጠቅማል ?',
        GOODAYNEED: 'ጉዳይ™ የሞባይል አፕን በመጠቀም በየእለቱ የሚያስፈልጎትን ማንኛውንም አይንት ጊዜያዊና ቋሚ ስራ ወይም ሰራተኛ እና አገልግሎቶችን ማግኘት ይችላሉ ። ለምሳሌ ለቤት-ውስጥ ስራዎች (ምግብ ማብሰል እና ጽዳት) ፣ አትክልተኛ ፣ ለልጆች አስጠኚ ፣ የመኪና መካኒክ ፣ ፀጉር ሰሪ ፣ የቧንቧ ሰራተኛ ፣ የሚሸጡ እቃዎች ... ወዘተ ። ሁሉንም አገልግሎቶች የሚያገኙት በነፃ ነው ። ስለዚህ የሞባይል ስልኮ ላይ ጉዳይ™ አፕን በመጫን የሚፈልጉትን ስራ ፣ ሰራተኛ ወይም አገልግሎት ካሉበት ከቤትዎ ሳይንቀሳቀሱ  ፈልገው ማግኘት ይችላሉ ። ጉዳይ™ ን በመጠቀም ጉዳዮን ይግደሉ!',
        GOODAYWHATELSEQ: 'ሌላስ ?',
        GOODAYWHATELSE: 'B2B2C ዲጂታል ማርኬቲንግ ለ GoodayOnline™ ዋናው ስራችን ነው። የማርኬቲንግ እና ማስታወቂያ ማሳለጫ የቴክኖሎጂ መሳሪያችንን በመጠቀም በሁሉም ደረጃ ላይ የሚገኙ የንግድ ድርጅቶችን ከተለመደው የማርኬቲንግ እና ማስታወቂያ ዋጋ በጣም ባነሰ ውጤታማ እናደርጋለን። የተለምዶ የማርኬቲንግ እና ማስታወቂያ መንገዶች በሚፈጥሩት ብክነት እና መጨናነቅ በኢትዮጵያ ውስጥ ትናንሽ የንግድ ድርጅቶች የተዋጡና እድገት አልባ ናቸው ። ይህንን ተግዳሮት ለመፍታት GoodayOnline™ ትክክለኛ የዳታ ጠቋሚና ማሳለጫ መሳሪያ ይጠቀማል።',

    },
    menuItems: {
        SIGNUP: 'ይመዝገቡ',
        SIGNIN: 'ይግቡ',
        HOME: 'መነሻ',
        SETTINGS: 'ምርጫዎች',
        SIGNOUT: 'ይውጡ',
        MYGOODAY: 'የኔ ጉዳይ',
    },
    myGooday: {
        SEARCH: 'ፈልግ',
        POST: 'ለጥፍ',
        searchMenu: {
            HEADER: 'ከተማ ፣ ሰፈር እና የሚፈልጉትን ጉዳይ ይምረጡ',
            SELECTCITY: 'ጉዳይዎት የት ከተማ ነው ?',
            SELECTHOOD: 'ጉዳይዎት የት ሰፈር ነው ?',
            SELECTGOODAY: 'ጉዳይዎት ምን በተመለከተ ነው ?',
            FINDGOODAY: 'ጉዳይ ግደል',
        },
    },
    postMenu: {
        NEWGOODAY: 'አዲስ ጉዳይ',
        ITEM1: '1. ከተማ ይምረጡ',
        ITEM2: '2. ሰፈር ይምረጡ (ከ 3 አይብለጥ)',
        ITEM3: '3. ጉዳይ ይምረጡ (ከ 3 አይብለጥ)',
        ITEM4: '4. ስለ ጉዳዩ ማስታወቂያ ትንሽ ዝርዝር ይጨምሩ',
        ITEM6: '6. በ GoodayOnline™ የ ግላዊነት እና ዳታ አጠቃቀም ፖሊሲ ይስማማሉ ?',
        POST: 'ጉዳይ ለጥፍ',
        CITYERROR: 'ከተማ አስፈላጊ ነው',
        HOODERROR: 'ሰፈር አስፈላጊ ነው',
        GIGERROR: 'ጉዳይ አስፈላጊ ነው',
        INTROERROR: 'ማስታወቂያ አስፈላጊ ነው',
        INTROMAXERROR: 'መስታወቂያ ከ 120 ፊደል መብለጥ የለበትም',
        POLICYERROR: 'ለመቀጠል በፖሊሲው መስማማት ግድ ነው',

    },
    cities: {
        ADDISABABA: {
            NAME: 'አዲስ አበባ',
            neighborHood: {
                PIASA: 'ፒያሳ',
                ARATKILO: 'አራትኪሎ',
                KASANCHIS: 'ካሳንቺስ',
                BOLE: 'ቦሌ',
                MEXICO: 'ሜክሲኮ',
                LAFTO: 'ላፍቶ',
                KERA: 'ቄራ',
            },
        },
        DIREDAWA: {
            NAME: 'ድሬ ዳዋ',
            neighborHood: {

            },
        },
        MEKELE: {
            NAME: 'መቀሌ',
            neighborHood: {

            },
        },
        BAHIRDAR: {
            NAME: 'ባህር ዳር',
            neighborHood: {

            },
        },
        GONDER: {
            NAME: 'ጎንደር',
            neighborHood: {

            },
        },
        DESSIE: {
            NAME: 'ደሴ',
            neighborHood: {

            },
        },
        AWASA: {
            NAME: 'አዋሳ',
            neighborHood: {

            },
        },
        JIMMA: {
            NAME: 'ጂማ',
            neighborHood: {

            },
        },
        BISHOFTU: {
            NAME: 'ቢሾፍቱ',
            neighborHood: {

            },
        },
        HARAR: {
            NAME: 'ሐረር',
            neighborHood: {

            },
        },
        DEBREBIRHAN: {
            NAME: 'ደብረ ብርሃን',
            neighborHood: {

            },
        },
        JIGJIGA: {
            NAME: 'ጂጂጋ',
            neighborHood: {

            },
        },
        SHASHEMANAE: {
            NAME: 'ሻሸመኔ',
            neighborHood: {

            },
        },

    },
    gigs: {
        FORSALE: 'የሚሸጥ እቃ',
        MAIDCOOKING: 'የቤት ስራ - ማብሰል',
        MAIDCLEANING: 'የቤት ስራ - ፅዳት',
        MAIDNANNY: 'ሞግዚት',
        TUTOR: 'አስጠኚ',
        DRIVER: 'ሹፌር',
        SATELLITEDISH: 'ዲሽ ጥገና',
        COMPUTERMAINT: 'ኮምፒውተር ጥገና',
        CARPENTER: 'አናጺ',
        PLUMBER: 'ቧንቧ ሰራተኛ',
        CARWASH: 'መኪና አጣቢ',
        GARDENER: 'አትክልተኛ',
        TRASHPICKUP: 'ቆሻሻ ማስወገድ',
        BEUTYHAIR: 'ፀጉር ሰሪ (ለሴት)',
        BARBER: 'ፀጉር ቆራጭ (ለወንድ)',
        BEUTYMAKEUP: 'ሜካፕ አርቲስት',
        MASSAGE: 'ማሳጅ',
        ELECTRICIAN: 'ኤሌክትሪሺያን',
        HOUSEPAINTING: 'ቀለም ቀቢ',
        OTHER: 'ሌላ - ያለተጠቀሰ'
    },
    signIn: {
        SIGNIN: 'ይግቡ',
        ENTERPHONE: 'ስልክ ቁጥሮትን ያስገቡ',
        VERIFYHINT: 'አረጋግጥ የሚለውን ቁልፍ ነክተው የመግቢያ ኮድ በአጭር ፅሁፍ መልክት ይጠብቁ',
        NEWPHONE: 'ስልክ ቁጥሩ ለሲስተሙ አዲስ ነው ። እባክዎን ይመዝገቡ!',
        ENTERSMSCODE: 'በአጭር ፅሁፍ መልክት የደረሶትን ኮድ ያስገቡ',
        SMSFAILED: 'የአጭር ፅሁፍ መልክት ማረጋገጫ አልተሳካም፣ ስልክ ቁጥሩ ትክክል እንደሆነ ያጣሩና ይሞክሩ ',
        BADSMSCODE: 'ያስገቡት ኮድ ትክክል አደለም፣ ሌላ ኮድ ይሞክሩ',
        VERIFY: 'ስልክ አረጋግጥ',
        PHONEREQERROR: 'ስልክ ቁጥር የሚያስፈልግ ነው',
        PHONEDIGITSERROR: 'ስልክ ቁጥር 9 አሀዝ መሆን አለበት',


    },
    signUp: {
        FIRSTNAME: 'ስም',
        LASTNAME: 'የአባት ስም',
        PHONE: 'ስልክ',
        EMAIL: 'ኢ-ሜል',
        CONFIRMEMAIL:'ኢ-ሜሉን ያረጋግጡ',
        CITY: 'ከተማ',
        ENTERCITY: 'ከተማዎትን ያስገቡ',
        POLICYAGREE: 'በ GoodayOnline™ የ ግላዊነት እና ዳታ አጠቃቀም ፖሊሲ ይስማማሉ ?',
        VERIFYHINT: 'አረጋግጥ የሚለውን ቁልፍ ነክተው የመመዝገቢያ ኮድ በአጭር ፅሁፍ መልክት ይጠብቁ',
        ACCOUNTEXISTS: 'በዚህ ስልክ የተመዘገበ አካውንት አለ፣ ወደ አካውንቱ ገብተዋል',
        ROUTEDSIGNUP: 'ስልክ ቁጥሩ ለሲስተሙ አዲስ ነው ። እባክዎን ይመዝገቡ!',
        REGISTER: 'ተመዝግበው ይግቡ',
        CLEAR: 'ሰርዝ',
        NAMELENERROR: 'ስም ከ10 ፊደል መብለጥ የለበትም',
        NAMEREQERROR: 'ስም አስፈላጊ ነው',
        EMAILVALIDERROR: 'ኢ-ሜል አድራሻው ትክክል መሆን አለበት',
        EMAILREQERROR: 'ኢ-ሜል አስፈላጊ ነው',
        EMAILMATCHERROR: 'ኢ-ሜል አድራሻዎቹ አንድ አይነት አደሉም',
        POLICYERROR: 'ለመቀጠል በፖሊሲያችን መስማማት አለቦት',
        CITYERROR: 'ከተማ አስፈላጊ ነው',
    },
    
}